module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-16.03720163.png";